import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {OrgWalletTransactionDto} from "../org-wallet-transaction.dto";
import {Feature} from "../../../libs/enum/feature.enum";

export class SearchOrgWalletTransactionRes extends SearchResultDto {

  public override readonly items: OrgWalletTransactionDto[] = [];

  constructor(init?: Partial<SearchOrgWalletTransactionRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchOrgWalletTransactionItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchOrgWalletTransactionItem extends OrgWalletTransactionDto implements SearchItem {

  public override readonly id!: string;
  public readonly featureType: Feature | undefined;

  constructor(init?: Partial<SearchOrgWalletTransactionItem>) {
    super(init);
    Object.assign(this, init);
  }
}
